<template>
    <div class="product">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.id" class="display-block">
                        {{model.title}} <span v-html="model.typeLabel"></span>
                    </h4>
                    <h4 v-else>Create Product</h4>
                    <h5 v-if="model.project">Product - {{model.project.name}}</h5>
                </header>

                <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate"
                      data-vv-scope="product">
                    <fieldset>
                        <legend>Product</legend>

                        <div class="form-group">
                            <div class="radio-section has-feedback">
                                <div>
                                    <input id="product-type-backlog-2" name="Product[type]" type="radio" value="4"
                                           v-model.number="model.type">
                                    <label for="product-type-backlog-2">TV Streaming</label>
                                </div>
                                <div>
                                    <input id="product-type-backlog" name="Product[type]" type="radio" value="0"
                                           v-model.number="model.type">
                                    <label for="product-type-backlog">TV</label>
                                </div>
                                <div>
                                    <input id="product-type-to-do" name="Product[type]" type="radio" value="1"
                                           v-model.number="model.type">
                                    <label for="product-type-to-do">Wireless</label>
                                </div>
                                <div>
                                    <input id="product-type-doing" name="Product[type]" type="radio" value="2"
                                           v-model.number="model.type">
                                    <label for="product-type-doing">Wired</label>
                                </div>
                                <div>
                                    <input id="product-type-iot" name="Product[type]" type="radio" value="5"
                                           v-model.number="model.type">
                                    <label for="product-type-iot">IoT</label>
                                </div>
                                <div>
                                    <input id="product-type-done" name="Product[type]" type="radio" value="3"
                                           v-model.number="model.type">
                                    <label for="product-type-done">Misc</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('product.Product[title]')}">
                            <label for="product-title">Title</label>
                            <input id="product-title"
                                   v-validate="'required'"
                                   v-model="model.title"
                                   name="Product[title]"
                                   type="text"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('product.Product[title]')" class="help-block">
                                {{ errors.first('product.Product[title]') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('product.Product[description]')}">
                            <label for="product-description">Description</label>
                            <textarea id="product-description"
                                      v-model="model.description"
                                      name="Product[description]"
                                      type="text"
                                      class="form-control"
                                      aria-required="true">
                            </textarea>

                            <span v-show="errors.has('product.Product[description]')" class="help-block">
                                {{ errors.first('product.Product[description]') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('product.Product[agreement_title]')}">
                            <label for="product-agreement-title">Agreement Title</label>
                            <input id="product-agreement-title"
                                   v-model="model.agreement_title"
                                   name="Product[agreement_title]"
                                   type="text"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('product.Product[agreement_title]')" class="help-block">
                                {{ errors.first('product.Product[agreement_title]') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('product.Product[agreement_description]')}">
                            <label for="product-agreement-description">Agreement Description</label>
                            <textarea id="product-agreement-description"
                                      v-model="model.agreement_description"
                                      name="Product[agreement_description]"
                                      type="text"
                                      class="form-control"
                                      aria-required="true">
                            </textarea>

                            <span v-show="errors.has('product.Product[agreement_description]')" class="help-block">
                                {{ errors.first('product.Product[agreement_description]') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('product.Product[upgrades_available]')}">
                            <div class="checkbox">
                                <label for="product-upgrade-available">
                                    <input v-model.boolean="model.upgrades_available"
                                           type="checkbox"
                                           id="product-upgrade-available"
                                           name="Product[upgrades_available]">
                                    <b>Upgrades Available</b>
                                </label>
                            </div>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('product.Product[display_product_order]')}">
                            <label for="display-product-order">Display Order</label>
                            <input id="display-product-order"
                                               v-validate="'min_value:0'"
                                               v-model="model.display_product_order"
                                               name="Product[display_product_order]"
                                               type="number"
                                               class="form-control">

                            <span v-show="errors.has('product.Product[display_product_order]')" class="help-block">
                                {{ errors.first('product.Product[display_product_order]') }}
                            </span>
                        </div>

                        <div class="row">
                            <div class="col-md-8 col-lg-6 form-group has-feedback"
                                 :class="{'has-error': errors.has('product.Product[value]')}">

                                <div v-if="valueSuffix !== ''">
                                    <label for="product-value">Metric Values</label>
                                    <div class="input-group">
                                        <input id="product-value"
                                               v-validate="'min_value:0'"
                                               v-model="model.value"
                                               name="Product[value]"
                                               type="number"
                                               class="form-control">

                                        <span class="input-group-addon">
                                            {{valueSuffix}}
                                        </span>
                                    </div>
                                </div>

                                <div v-if="model.type === 0">
                                    <div class="input-group">
                                        <input id="product-num-receivers"
                                            v-validate="'min_value:0|max_value:10'"
                                            v-model="model.num_receivers"
                                            name="Product[num_receivers]"
                                            type="number"
                                            class="form-control">

                                        <span class="input-group-addon">
                                            HD Receivers
                                        </span>
                                    </div>
                                    <div class="input-group">
                                        <input id="product-num-dvrs"
                                            v-validate="'min_value:0|max_value:10'"
                                            v-model="model.num_dvrs"
                                            name="Product[num_dvrs]"
                                            type="number"
                                            class="form-control">

                                        <span class="input-group-addon">
                                            HD DVRs
                                        </span>
                                    </div>
                                </div>

                                <span v-show="errors.has('product.Product[value]')" class="help-block">
                                    {{ errors.first('product.Product[value]') }}
                                </span>
                                <span v-show="errors.has('product.Product[num_receivers]')" class="help-block">
                                    {{ errors.first('product.Product[num_receivers]') }}
                                </span>
                                <span v-show="errors.has('product.Product[num_dvrs]')" class="help-block">
                                    {{ errors.first('product.Product[num_dvrs]') }}
                                </span>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-xs-6 form-group">
                                <button type="button" class="btn btn-sm btn-warning"
                                        v-if="model.created_at"
                                        @click="deleteModel"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div class="col-xs-6 form-group pull-right">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save Product
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    const UPGRADE_TYPE_SUPPORT_PHONE = 1;
    const UPGRADE_TYPE_LINK = 2;

    export default {
        mixins: [ model ],

        data() {
            return {
                UPGRADE_TYPE_LINK,
                UPGRADE_TYPE_SUPPORT_PHONE
            };
        },

        props: {
            projectId: {
                type: String,
                default: null
            },

            supportPhone: {
                type: String,
                required: true
            }
        },

        computed: {
            displaySupportPhone(){
                let displayPhone = this.supportPhone;
                if (displayPhone.length >= 10) {
                    displayPhone = `(${displayPhone.substring(displayPhone.length - 10, displayPhone.length - 7)}) ${displayPhone.substring(displayPhone.length - 7, displayPhone.length - 4)}-${displayPhone.substring(displayPhone.length - 4)}`
                }
                return displayPhone;
            },

            url(){
                if( this.model.id ){
                    return '/api/products/' + this.model.id;
                }
                else {
                    return '/api/products';
                }
            },

            saveValidationKey(){
                return 'product'
            },

            resourceKey(){
                return 'Product';
            },

            valueSuffix: function(){
                if( this.model.type === 0 ){
                    return 'Channels';
                }
                else if( this.model.type === 1 || this.model.type === 2 ){
                    return 'Mbps';
                }

                return '';
            },
        },

        methods: {
            beforeSave(){
                if( !this.model.created_at ){
                    this.model.project_id = this.projectId;
                }
            },

            getModelData(){
                return {
                    model: {
                        type: 0
                    }
                };
            },
        }
    }
</script>
